import React from "react";
import { Link } from "react-router-dom";
import Back from "shared/assets/images/svg/back_blue.svg";
import DxfGrid from "shared/component/dxf-grid/dxf-grid";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useBookingUsers } from "./booking-users.service";
import { t } from "i18next";
import { Column } from "devextreme-react/data-grid";

const BookingUsers = () => {
  const { t } = useTranslation();
  const { myUserSource } = useBookingUsers();

  return (
    <div className="settingHome grantedUsers">
      <div className="container">
        <div className="header">
          <div className="page-name">
            <Link className="linkBack" to="/settings">
              <img src={Back} alt="back" />
            </Link>
            <h1>{t("booking-user.my-users")}</h1>
          </div>
        </div>

        <hr className="hr mb-0" />

        <div className="dataTable">
          <DxfGrid
            dataSource={myUserSource}
            editing={{ confirmDelete: true, mode: "row", allowUpdating: true }}
            onSaved={() => toast.success("Password has been updated ")}
          >
            <Column dataField="supplier" caption={t("booking-user.supplier")} allowEditing={false} />
            <Column dataField="userName" caption={t("booking-user.user")} allowEditing={false} />
            <Column dataField="name" width="250" caption={t("booking-user.account")} allowEditing={false} />
            <Column dataField="Email" caption={t("booking-user.email")} allowEditing={false} />
            <Column dataField="officeid_code" caption={t("booking-user.id")} allowEditing={false} />
            <Column
              dataField="password"
              caption={t("booking-user.password")}
              allowSearch={false}
              customizeText={(e) => {
                return "*****";
              }}
            />
            <Column cellRender={(cell) => <UserActions cell={cell} />} />
          </DxfGrid>
        </div>
      </div>
    </div>
  );
};

export function UserActions({ cell, onEdit }) {
  const row = cell.data;

  // return <button onClick={()=>onEdit(row)} > edit </button>;
  return <></>;
}

export default BookingUsers;
